export default "__VITE_ASSET__Bmazeagz__"